import { useBackendApi } from './backendApi';
import { useEventsPublisher } from 'event-bus';
import { PERSON_UPDATED } from './peopleService';
import { Person } from './Types';

export interface CreateUserLinkRequest {
  externalUserId: string;
  connectionProfileId: number;
}

export interface UserLink {
  id: number;
  memberId: number;
  externalUserId: string;
  connectionProfileId: number;
}

export function useUserLinkService() {
  const nekstApi = useBackendApi();
  const eventsPublisher = useEventsPublisher();

  const linkMember = async (memberId: number, request: CreateUserLinkRequest): Promise<Person> => {
    const response = await nekstApi.post(`/teammembers/${memberId}/externaluserslinks`, request) as Person;

    eventsPublisher.publish(PERSON_UPDATED, {
      id: response.id,
      data: response
    });
    return response;
  };

  const unlinkMember = async (memberId: number, linkId: number): Promise<Person> => {
    const response = await nekstApi.delete(`/teammembers/${memberId}/externaluserslinks/${linkId}`) as Person;
    
    eventsPublisher.publish(PERSON_UPDATED, {
      id: response.id,
      data: response
    });
    return response;
  };

  return {
    linkMember,
    unlinkMember,
  };
} 